module.exports = __webpack_public_path__ + "media/application/images/ui/icons-action-bar-1720367182e20b15e19476f26e53a0dc.png";